<div class="container navtop">
   
  



        <!-- spinner -->
        <div *ngIf="IsWait" class="col-12">
          <div class="row justify-content-center mt-4">
            <mat-spinner class="mt-5" strokeWidth="19" [diameter]="100" color="primary"></mat-spinner>
          </div>
        </div>

       
           
            <div  *ngIf="!IsWait" class="row justify-content-center" >

                <mat-card  class="col-12 col-md-3 mx-3 my-4 cardCommunaute mat-elevation-z8" *ngFor="let item of members" >
                
                  <mat-card-content >
                    <!-- <mat-card-title class="text-center">{{item.title}}</mat-card-title> -->
                    <a href="{{item.link}}">

                      <img mat-card-image style="margin-bottom: 0px !important;"  [src]="sanitizeImageUrl('data:'+item.logo.mimetype+';base64,'+item.logo.source)"  alt="clem" >
      
                  </a>
                
                    <p style="margin-bottom: 0px !important;" *ngIf="item.texte !== '<p><br></p>'" class="text-center" [innerHTML]="item.texte"></p>
                </mat-card-content>
              
                
                <!-- <div class="row justify-content-center mt-5">
                  <button (click)="subscribeLink(item.link)" mat-stroked-button color="primary">S'inscrire</button>
                </div> -->

                </mat-card>
              </div>
              


   

   
</div>